import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom'; // ⭐ Added Routes
import { useTenant } from './Common/Contexts/TenantContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import WebsiteVisualizer from './WebsiteVisualizer';
import WebsiteManager from './WebsiteManager';


// Admin Import

// Templates
const Template_1 = lazy(() => import('./Templates/Template_1'));
const Template_2 = lazy(() => import('./Templates/Template_2'));
const Template_3 = lazy(() => import('./Templates/Template_3'));
const Template_4 = lazy(() => import('./Templates/Template_4'));
const Template_8 = lazy(() => import('./Templates/Template_8'));
const Template_31 = lazy(() => import('./Templates/Template_31'));
const Template_21 = lazy(() => import('./Templates/Template_21'));
const Template_32 = lazy(() => import('./Templates/Template_32'));
const Template_33 = lazy(() => import('./Templates/Template_33'));
const Template_34 = lazy(() => import('./Templates/Template_34'));
const Template_35 = lazy(() => import('./Templates/Template_35'));
const Template_36 = lazy(() => import('./Templates/Template_36'));
const Template_37 = lazy(() => import('./Templates/Template_37'));
const Template_38 = lazy(() => import('./Templates/Template_38'));
const templateMap = {
  Template_1,
  Template_2,
  Template_3,
  Template_4,
  Template_8,
  Template_31,
  Template_21,
  Template_32,
  Template_33,
  Template_34,
  Template_35,
  Template_36,
  Template_37,
  Template_38
};

function App() {
  const { tenantData, loading } = useTenant();

  if (loading) return (
     <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
     </div>
  );

  const ref = tenantData?.templateReference;
  const ActiveTemplate = templateMap[ref];

  return (
    <>
      <Routes>
        {/* ⭐ ADMIN ROUTE: This is available on all domains */}
         <Route path="/admin/website-manager" element={<WebsiteManager />} />
        <Route path="/admin/website-visualizer" element={<WebsiteVisualizer />} />

        {/* ⭐ PUBLIC WEBSITE ROUTE */}
        <Route path="*" element={
          !ActiveTemplate ? (
            /* Website Not Configured Screen */
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
              <div className="text-center p-5 shadow-sm bg-white rounded-4" style={{ maxWidth: '400px' }}>
                <h1 className="display-4 text-muted mb-3">404</h1>
                <h5 className="fw-bold">Website Not Configured</h5>
                <p className="text-secondary small">This domain is not associated with an active template.</p>
                <hr /><small className="text-muted">© 2026 Smart Travel Platform</small>
              </div>
            </div>
          ) : (
            /* Dynamically Loaded Template */
            <Suspense fallback={<div className="text-center p-5">Loading Website...</div>}>
              <ActiveTemplate />
            </Suspense>
          )
        } />
      </Routes>

      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;